define('lq/dispatcher',[
    'lq/runtimeDispatcher',
    'lq/busyIndicator'
], function (RuntimeDispatcher, busyIndicator) {
    'use strict';
    
    return new RuntimeDispatcher(busyIndicator);
});

